import { useQuery } from "@tanstack/react-query";
import { useState, useEffect } from "react";

const useUserQuery = () => useQuery({
   queryKey: ['/api/user'],
   staleTime: 3600 * 100
})

export default function useAuth() {
  const [token, setToken] = useState(null);
//   const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const { data: user, isLoading, refetch } = useUserQuery()
//   const { data: myLikes, isLoading: isLoadingLikes } = useQuery({
//    queryKey: ['/api/user?include=likes'],
//    select(data) {
//       return data
//    }
//   })

  useEffect(() => {
    let storedToken = localStorage.getItem("userToken");
    if (storedToken) {
      storedToken = storedToken.replaceAll('"', ''); // Remove any surrounding quotes
      setToken(storedToken);
      setIsAuthenticated(true);
    }
  }, []);

  const login = (token) => {
    localStorage.setItem("userToken", token);
    setToken(token);
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem("userToken");
    localStorage.removeItem("userData");
    setToken(null);
    setIsAuthenticated(false);
  };

  const refresh = () => {
   refetch().then(() => {
      localStorage.setItem("userData", JSON.stringify(user?.data));
      console.log('Refreshed user')
   })
  }

  return { token, user: user?.data, isLoading, isAuthenticated, login, logout, refresh };
}
